<template lang="">
  <div class="md-layout">
    <div class="md-layout-item md-layout md-alignment-center-right">
      <md-button v-if="checkRole()" class="md-success" @click="$router.push('/groups-list/group')">New Group</md-button>
    </div>
    <div class="md-layout-item md-medium-size-100 md-size-100">
      <md-card>
        <md-card-content>
          <md-table v-model="simpleGroupList" @md-selected="onSelect" v-if="simpleGroupList.length > 0">
            <md-table-row slot="md-table-row" slot-scope="{ item }" md-selectable="single">
              <md-table-cell md-label="ID" md-sort-by="id" md-numeric :class="'id-group'">{{ item.id }}</md-table-cell>
              <md-table-cell md-label="Group Name" md-sort-by="group_name">{{ item.group_name }}</md-table-cell>
              <md-table-cell md-label="Group Status" md-sort-by="status">{{ item.status }}</md-table-cell>
              <md-table-cell md-label="Num Lines" md-sort-by="num_line">{{ item.num_line }}</md-table-cell>
              <md-table-cell md-label="Total" md-sort-by="total">{{ item.total }}</md-table-cell>
            </md-table-row>
          </md-table>
          <span
            v-if="simpleGroupList.length == 0"
            style="
              display: flex;
              width: 100%;
              text-align: center;
              justify-content: center;
          "
          >
            No hay resultados
          </span>
        </md-card-content>
      </md-card>
    </div>
  </div>
</template>
<script>
import { GroupApi } from '@/openapi/src'

const groupApi = new GroupApi()

export default {
  name: 'Group',
  data() {
    return {
      simpleGroupList: [],
    }
  },
  methods: {
    checkRole() {
      return this.$root.hasBackendRole('group')
    },
    onSelect(item) {
      this.$router.push(`/groups-list/group/${item.id}`)
    },
    loadGroupList() {
      groupApi.getGroupListByHotelId(this.$root.hotelId, (error, data) => {
        if (!error) {
          this.simpleGroupList = data
        }
      })
    },
  },
  created() {
    this.loadGroupList()
  },
}
</script>
<style lang="scss">
.md-table-cell.id-group {
  width: 50px !important;
  max-width: 50px;
  min-width: 50px !important;
  .md-table-cell-container {
    overflow: hidden !important;
    //white-space: nowrap;
    text-overflow: ellipsis;
    padding-right: 10px;
  }
}
</style>
